import React from "react"
import "./App.css"
import FolderTree from "./components/FolderTree"
import { AppProvider } from "./contexts/AppContext"

const AppContent: React.FC = () => {
  return (
    <div className="App">
      <div className="content-pane">
        <div className="tab-panel models-panel">
          <FolderTree />
        </div>
      </div>
    </div>
  )
}

const App: React.FC = () => {
  return (
    <AppProvider>
      <AppContent />
    </AppProvider>
  )
}

export default App
